import PopUpContactUs from 'components/ContactUs/PopUpContactUs';
import { GetStaticProps } from 'next';
import React from 'react';
import { Metadata } from 'components/Metadata';
import { ORIGIN } from 'src/constants';
import { useRouter } from 'next/router';
import Header from 'components/layouts/Header/Header';
import GoogleAnalytics from 'src/ga/grouping';

const ErrorPage: React.FC = () => {
  const { asPath } = useRouter();
  return (
    <>
      <Metadata
        {...{
          title: `Not Found | CondoBlackBook`,
          url: `${ORIGIN}${asPath}`,
        }}
      />
      <GoogleAnalytics pageGroup={'Other'} />
      <Header />
      <section className="container flex flex-col">
        <div className="flex justify-center text-git sxl py-14">
          Sorry, we can't seem to find the page you are looking for.
        </div>
        <div className="flex justify-center text-git sxl py-14">
          Didn’t find what you want?&nbsp;
          <PopUpContactUs contactUsNotButton={'Contact us'} />
          &nbsp;for exclusive off-market listings
        </div>
      </section>
    </>
  );
};

export default ErrorPage;

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};
